import React, {Suspense, lazy} from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import routes from './../../config/page-route.jsx';
import { PageSettings } from './../../config/page-settings.js';
import ErrorBoundary from './../error-boundary/error-boundary.jsx';
import Loader from '../loader/loader.jsx';

const Error404 = lazy(() => import('../../pages/error/error-404.js'));

function setTitle(path, routeArray) {
	var pageTitle;
	for (var i=0; i < routeArray.length; i++) {
		if (routeArray[i].path === path) {
			pageTitle = 'Doit Portal Application System | ' + routeArray[i].title;
		}
	}
	document.title = (pageTitle) ? pageTitle : 'Doit Platform | Portal Application System';
}

class Content extends React.Component {
	componentDidMount() {
		setTitle(this.props.history.location.pathname, routes);
	}
	UNSAFE_componentWillMount() {
		this.props.history.listen(() => {
				setTitle(this.props.history.location.pathname, routes);
		});
	}

	render() {
		return (
			<PageSettings.Consumer>
				{({pageContentFullWidth, pageContentClass, pageContentInverseMode}) => (
					<div className={'content ' + (pageContentFullWidth ? 'content-full-width ' : '') + (pageContentInverseMode ? 'content-inverse-mode ' : '') + pageContentClass}>
						<ErrorBoundary>
							<Suspense fallback={<Loader/>}>
								<Switch>
									{routes.map((route, index) => (
										<Route
											key={index}
											path={route.path}
											exact={route.exact}
											component={route.component}
										/>
									))}
									<Route component={Error404}/>
								</Switch>
							</Suspense>
						</ErrorBoundary>
					</div>
				)
			}
			</PageSettings.Consumer>
		)
	}
}

export default withRouter(Content);
